/* WCS */
export default {
  install(Vue, options) {
    // 1. 전역 메소드 또는 속성 추가
    Vue.myGlobalMethod = function () {
      Vue.prototype.$header_key = Math.round(Math.random() * 1000);
    }
  }
}